<template>
  <div>
    <div class="query-select">
      <el-form ref="queryForm" :model="queryForm" :inline="true">
        <el-form-item label="题干：">
          <el-input
            size="small"
            v-model="queryForm.questionStem"
            placeholder="请输入题干"
          ></el-input>
        </el-form-item>
        <el-form-item label="题型：">
          <el-select
            clearable
            @change="getTableInfo"
            size="small"
            v-model="queryForm.questionType"
            placeholder="请选择题型"
          >
            <el-option
              v-for="item in handsOnQuestionTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="等级：">
          <el-select
            clearable
            @change="getTableInfo"
            size="small"
            v-model="queryForm.courseLevel"
            placeholder="请选择难度等级"
          >
            <el-option
              v-for="item in examLevel"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建日期：" class="mr-left">
          <el-date-picker
            size="small"
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            @change="getTableInfo"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="div_select_button">
        <el-button
          type="primary"
          icon="el-icon-search"
          plain
          size="small"
          round
          @click="getTableInfo"
          >查询</el-button
        >
        <el-button
          type="warning"
          icon="el-icon-refresh-left"
          plain
          size="small"
          round
          @click="reset"
          >重置</el-button
        >
        <el-button
          type="success"
          icon="el-icon-plus"
          plain
          size="small"
          round
          @click="openForm('create')"
          >新增</el-button
        >
      </div>
    </div>
    <div class="main-table">
      <el-table
        :data="tableData"
        style="width: 85vw"
        border
        stripe
        size="small"
        v-loading="loading"
        header-cell-class-name="table-header"
      >
        <el-table-column align="center" type="index" width="50">
        </el-table-column>
        <el-table-column
          align="center"
          prop="questionStem"
          label="题干"
          width="500"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="courseLevel"
          label="等级"
          width="100"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ getExamLabel(scope.row.courseLevel) }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="questionType" label="题型">
          <template slot-scope="scope">
            {{
              handsOnQuestionTypes.find(
                item => item.value == scope.row.questionType
              ).label
            }}
          </template>
        </el-table-column>

        <el-table-column
          width="360"
          header-align="center"
          align="center"
          prop="url"
          label="题目资源"
        >
          <template slot-scope="scope">
            <FileDetail :data="scope.row" size="100" is-table></FileDetail>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="createTime" label="创建日期">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createTime, "YYYY-MM-DD") }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="300">
          <template slot-scope="scope">
            <el-button
              size="mini"
              round
              plain
              type="warning"
              @click="openForm('edit', scope.row.questionsId)"
              >编辑</el-button
            >

            <el-button
              type="danger"
              plain
              size="mini"
              round
              @click="removeClick(scope.row.questionsId)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="10"
        layout="total, prev, pager, next"
        :current-page.async="queryForm.pageNum"
        :total="totalCount"
      >
      </el-pagination>
    </div>
    <HandsOnForm ref="formRef" @success="getTableInfo"></HandsOnForm>
  </div>
</template>

<script>
import { formatDate } from "@/utils/formatDate.js";
import { getList, deleteInfo } from "@/api/handsOnBank";
import { handsOnQuestionTypes, examLevel, getExamLabel } from "@/utils/dict.js";
import HandsOnForm from "./HandsOnForm.vue";
import FileDetail from "@/components/FileDetail.vue";
export default {
  name: "HandsOnBank",
  components: { HandsOnForm, FileDetail },
  data() {
    return {
      examLevel,
      handsOnQuestionTypes,
      loading: false,
      tableData: [],
      totalCount: 0,
      dateRange: null,
      queryForm: {
        pageNum: 1,
        pageSize: 10,
        courseLevel: ""
      }
    };
  },

  methods: {
    formatDate,
    getExamLabel,
    openForm(type, id = null) {
      this.$refs.formRef.open(type, id);
    },
    reset() {
      this.queryForm = {
        pageNum: 1,
        pageSize: 10
      };
      this.dateRange = null;
      this.getTableInfo();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNum = val;
      this.getTableInfo();
    },
    async getTableInfo() {
      let obj = {};
      if (this.dateRange) {
        obj = {
          startTime: this.dateRange[0] + " 00:00:00",
          endTime: this.dateRange[1] + " 23:59:59"
        };
      }
      const res = await getList({ ...this.queryForm, ...obj });
      console.log(res);
      this.tableData = res.data.data.rows;
      this.totalCount = res.data.data.total;
    },
    async removeClick(id) {
      this.$confirm("此操作将删除该内容,并进入回收站,是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const res = await deleteInfo(id);
          console.log(res.data);
          if (res.data.code === 200) {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getTableInfo();
          } else {
            this.$message({
              type: "warning",
              message: res.data.msg
            });
          }
        })
        .catch(() => {});
    }
  },
  mounted() {
    this.getTableInfo();
  }
};
</script>

<style scoped lang="less"></style>



// WEBPACK FOOTER //
// src/views/Bank/HandsOnBank/index.vue